/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {InviteState} from './invite.reducer';

// Selector functions
const inviteData =
  createFeatureSelector<InviteState>('ss-cord.invite');

export const groupFilter = createSelector(
  inviteData,
  (state: InviteState) => state.groupFilter
);

export const clientFilter = createSelector(
  inviteData,
  (state: InviteState) => state.clientFilter
);

export const participantUsernameFilter = createSelector(
  inviteData,
  (state: InviteState) => state.participantUsernameFilter
);

export const adultUsernameFilter = createSelector(
  inviteData,
  (state: InviteState) => state.adultUsernameFilter
);

export const checkParticipantHasAssociatedLar = createSelector(
  inviteData,
  (state: InviteState) => state.participantHasAssociatedLar
);

export const emailPreviewDataInfo = createSelector(
  inviteData,
  (state: InviteState) => state.emailPreviewDataInfo
);

export const createUserDataInfo = createSelector(
  inviteData,
  (state: InviteState) => state.createUserDataInfo
);

export const inviteUser = createSelector(
  inviteData,
  (state: InviteState) => state.inviteUser
);
